import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useDeleteDialog from './useDeleteDialog';
import { Trans } from "@lingui/react/macro"


const DeleteDialog = () => {
  const { open, onConfirm } = useSelector((state: {'deleteDialog': any}) => state.deleteDialog);
  const { closeDialog } = useDeleteDialog();

  return (
    <div>
      <Dialog open={open} onClose={() => closeDialog()}>
        <DialogTitle><Trans>Confirm Delete</Trans></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Trans>Please confirm delete of the entity.</Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button data-testid="delete-dialog-cancel-button" onClick={() => closeDialog()}><Trans>Cancel</Trans></Button>
          <Button data-testid="delete-dialog-confirm-button" onClick={() => onConfirm('delete')}><Trans>Confirm</Trans></Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteDialog;
